import { InfoCircle, Information, TickCircle } from 'iconsax-react';
import type { ReactElement } from 'react';

import { ToastAlertVariants } from '../ToastContext';

export const ToastAlertIcons: Record<ToastAlertVariants, ReactElement> = {
  [ToastAlertVariants.success]: <TickCircle />,
  [ToastAlertVariants.error]: <Information />,
  [ToastAlertVariants.info]: <InfoCircle />,
};
